import Store from '@/store';

export function setYoyakuApp() {
  updateApp('yoyaku');
}

export function setSignageApp() {
  updateApp('signage');
}

function updateApp(app: string) {
  Store.commit('updateApp', app);
}
